var map = {
	"./1.png": 996,
	"./10.png": 606,
	"./2.png": 463,
	"./3.png": 918,
	"./4.png": 337,
	"./5.png": 88,
	"./6.png": 259,
	"./7.png": 754,
	"./8.png": 781,
	"./9.png": 868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;